import React from 'react'
import { connect } from 'react-redux'
import Pagination from 'react-js-pagination'
import Modal from 'react-responsive-modal'
import BrandActions from '../../Redux/BrandRedux'
import CreateBrand from '../../Containers/Ecommerce/CreateBrand'
import AssignCategory from '../../Containers/Ecommerce/AssignCategory'
import RemoveCategory from '../../Containers/Ecommerce/RemoveCategory'
import UpdateBrand from '../../Containers/Ecommerce/UpdateBrand'

class ManageBrand extends React.Component {
  constructor (props) {
    super(props)
    this.dateformat = 'Y-MM-DD'
    this.state = {
      showModal: null,
      detail: {},
      page: 1
    }
  }

  componentDidMount = () => {
    this._fetchBrand()
  }

  _fetchBrand = (event) => {
    if (event) { event.preventDefault() }
    let filter = ''
    this.props.getBrand(filter)
  }

  _changePage = (page) => {
    this.setState({ page })
    setTimeout(() => { this._fetchBrand() }, 250)
  }

  _toggleModal = (modalId = null) => {
    this.setState({ showModal: modalId })
    if (!modalId) {
      this._fetchBrand()
    }
  }

  _selectItem = (item, action) => {
    this.setState({ detail: item })
    this._toggleModal(action)
  }

  _deleteBrand = () => {
    this.props.deleteBrand(this.state.detail.id)
    setTimeout(() => {
      this._toggleModal()
    }, 250)
  }

  render () {
    const { brand } = this.props
    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3 justify-content-between'>
            <h3 className='title mr-auto'>Manage Brand
              {
                (brand.fetching || brand.processing) &&
                <div className='badge badge-info ml-2'>{ brand.fetching ? 'Loading' : 'Processing' } ...</div>
              }
            </h3>
            <button className='btn btn-primary' onClick={() => this._toggleModal('create-brand')}><i className='fa fa-plus' /> Create Brand</button>
          </div>
        </header>
        <section className='section'>
          <div className='card'>
            {!(brand.fetching || brand.processing) && brand.err &&
              <div className='alert alert-danger'>{brand.err}</div>
            }
            <table className='table table-hover table-striped' style={{ minWidth: '100%' }}>
              <thead>
                <tr>
                  <th className='text-center'>Brand Name</th>
                  <th className='text-center'>Assigned Categories</th>
                  <th className='text-center'>Edit Category</th>
                  <th className='text-center'>Edit Brand</th>
                  <th className='text-center'>Delete Brand</th>
                </tr>
              </thead>
              <tbody>
                {
                  !brand.data || !brand.data.length
                    ? <tr>
                      <td colSpan='7' className='text-center'>No data</td>
                    </tr>
                    : brand.data.map((item, i) => (
                      <tr key={i}>
                        <td className='text-center'>{ item.name }</td>
                        {
                          !item.categories || !item.categories.length
                            ? <td className='text-center'>- No Category -</td>
                            : <td className='text-center'>
                              { item.categories.map((x) => x.name).join(', ') }
                            </td>
                        }
                        <td className='text-center'>
                          <button className='btn btn-info' onClick={() => this._selectItem(item, 'assign-category')}>
                            <i className='fa fa-plus-circle' />
                          </button>
                          <button className='btn btn-danger' onClick={() => this._selectItem(item, 'remove-category')}>
                            <i className='fa fa-minus-circle' />
                          </button>
                        </td>
                        <td className='text-center'>
                          <button className='btn btn-primary' onClick={() => this._selectItem(item, 'edit-brand')}>
                            <i className='fa fa-edit' /> Edit
                          </button>
                        </td>
                        <td className='text-center'>
                          <button className='btn btn-danger' onClick={() => this._selectItem(item, 'delete-brand')} >
                            <i className='fa fa-trash' /> Delete
                          </button>
                        </td>
                      </tr>
                    ))
                }
              </tbody>
            </table>
          </div>
        </section>
        <section>
          {
            (brand.data && brand.data.total > 10) &&
            <Pagination
              innerClass='pagination'
              itemClass='page-item'
              linkClass='page-link'
              activePage={brand.data.page || this.state.page}
              itemsCountPerPage={10}
              totalItemsCount={brand.data.total}
              pageRangeDisplayed={5}
              onChange={this._changePage}
            />
          }
        </section>

        {/* Modal create brand */}
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'create-brand'} onClose={this._toggleModal} closeOnOverlayClick>
          <CreateBrand closeModal={() => this._toggleModal()} />
        </Modal>

        {/* Modal assign category */}
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'assign-category'} onClose={this._toggleModal} closeOnOverlayClick>
          <AssignCategory detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        {/* Modal remove category */}
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'remove-category'} onClose={this._toggleModal} closeOnOverlayClick>
          <RemoveCategory detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        {/* Modal edit brand */}
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'edit-brand'} onClose={this._toggleModal} closeOnOverlayClick>
          <UpdateBrand detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal open={this.state.showModal === 'delete-brand'} onClose={this._toggleModal} closeOnOverlayClick>
          <section className='section' style={{ width: '40vw' }}>
            <div className='title-block'>
              <h3>Delete Brand</h3>
            </div>
            <div className='text-center'>
              <h5>
                Confirm "{this.state.detail.name}" brand deletion?
              </h5>
            </div>
            <div className='text-center'>
              <button className='btn btn-lg btn-secondary mr-2' onClick={() => this._toggleModal()}>Cancel</button>
              <button className='btn btn-lg btn-danger' onClick={() => this._deleteBrand()}>Delete</button>
            </div>
          </section>
        </Modal>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  brand: state.brand
})

const dispatchToProps = (dispatch) => ({
  getBrand: (filter) => dispatch(BrandActions.getBrandRequest(filter)),
  deleteBrand: (id) => dispatch(BrandActions.deleteBrandRequest(id))
})

export default connect(stateToProps, dispatchToProps)(ManageBrand)



// WEBPACK FOOTER //
// ./src/Pages/Ecommerce/ManageBrand.js